import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW1108Model } from '../kymw1108.model';

// リクエスト構造
export interface GetEbaseCandidateListRequest {
  parameter: {
    /** JANコード */
    JanCode: string;
  };
}

// レスポンス構造
export interface GetEbaseCandidateListResponse {
  /** eBASE 取込商品候補一覧 */
  GoodInfoList: {
    /** Pコード */
    PCode: string;
    /** アイテムコード */
    ItemCode: string;
    /** JANコード */
    JanCode: string;
    /** 商品名 */
    GoodsName: string;
    /** 規格名 */
    StandardName: string;
    /** 入数 */
    ContainNum: number;
    /** 仕様書コード */
    EBaseSpecCode: string;
    /** 最終更新日 (YYYY/MM/DD 形式) */
    UpdateDate: string;
  }[];
}

/** eBASE 取込商品候補一覧取得 サービス */
@Injectable({
  providedIn: 'root'
})
export class GetEbaseCandidateListService extends PlessJsonResponderSub<GetEbaseCandidateListResponse> {
  model: KYMW1108Model;
  private requestData: GetEbaseCandidateListRequest;
  private successFunc: (response: GetEbaseCandidateListResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @returns {PlessRequest} リクエストJSON
   */
  private getBody(janCode: string): PlessRequest {
    this.requestData = {
      parameter: {
        JanCode: janCode,
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetEbaseCandidateListService
   */
  execute(model: KYMW1108Model, janCode: string, func?: (response: GetEbaseCandidateListResponse) => void): void {
    this.model = model;
    if (func) {
      this.successFunc = func;
    }
    this.send('getEbaseCandidateList', this.getBody(janCode));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetEbaseCandidateListService
   */
  success(data: GetEbaseCandidateListResponse) {
    if (this.successFunc) {
      this.successFunc(data);
    }
  }

}
